'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _types = require('redux/modules/types');

var _containers = require('../containers');

var _connectData = require('helpers/connectData');

var _connectData2 = _interopRequireDefault(_connectData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchData(getState, dispatch) {
  var state = getState().types;
  return dispatch((0, _types.index)(state.showAll));
}

var TypesContainer = (_dec = (0, _connectData2.default)(fetchData), _dec(_class = function (_Component) {
  (0, _inherits3.default)(TypesContainer, _Component);

  function TypesContainer() {
    (0, _classCallCheck3.default)(this, TypesContainer);
    return (0, _possibleConstructorReturn3.default)(this, (TypesContainer.__proto__ || (0, _getPrototypeOf2.default)(TypesContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(TypesContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBodyClassname2.default,
        { className: 'types' },
        _react2.default.createElement(_containers.EntitiesContainer, { entity: 'types' })
      );
    }
  }]);
  return TypesContainer;
}(_react.Component)) || _class);
exports.default = TypesContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TypesContainer.js
// module id = 1189
// module chunks = 0